import { Component } from '@angular/core';

interface ProgramCard {
  title: string;
  years: number;
  routerLink?: string;
  href?: string;
  learnMoreTarget?: string;
  applyHref: string;
  shareOpen?: boolean;
}

const NOPAPERFORMS_URL = 'https://raisoni.nopaperforms.com/rgi';
const GOOGLE_FORM_URL = 'https://forms.gle/1P58ZY7EvjJnVxD38';

@Component({
  selector: 'app-academic-navigation',
  templateUrl: './academic-navigation.component.html',
  styleUrls: ['./academic-navigation.component.scss']
})
export class AcademicNavigationComponent {

  activeTab: string = 'ug';

  ugPrograms: ProgramCard[] = [
    { title: 'B.Tech in CS Engg(AI)', years: 4, routerLink: '/courses/artificial-intelligence', applyHref: NOPAPERFORMS_URL },
    { title: 'First Year Engg', years: 4, routerLink: '/courses/first-year-engineering', applyHref: NOPAPERFORMS_URL },
    { title: 'B.Tech in Computer Engg', years: 4, routerLink: '/courses/computer-engineering', applyHref: NOPAPERFORMS_URL },
    { title: 'B.Tech in IT', years: 4, routerLink: '/courses/information-technology', applyHref: NOPAPERFORMS_URL },
    { title: 'B.Tech in Electro & Telecomm', years: 4, routerLink: '/courses/electronics-and-telecommunication', applyHref: NOPAPERFORMS_URL },
    { title: 'B.Tech in Mech Engg', years: 4, routerLink: '/courses/mechanical-engineering', applyHref: NOPAPERFORMS_URL },
    { title: 'B.Tech in Civil Engg', years: 4, routerLink: '/courses/civil-engineering', applyHref: NOPAPERFORMS_URL },
    { title: 'B.Tech in Electrical Engg', years: 4, routerLink: '/courses/electrical-engineering', applyHref: NOPAPERFORMS_URL },
    { title: 'B.Tech in Data Science', years: 4, routerLink: '/courses/data-science', applyHref: NOPAPERFORMS_URL },
    { title: 'B.Tech in CS & Engg(AI & ML)', years: 4, routerLink: '/courses/cse-ai-machine-learning', applyHref: NOPAPERFORMS_URL },
    { title: 'B.Tech in CS & Engg(Cyb Sec)', years: 4, routerLink: '/courses/btech-cse-cyber-security', applyHref: NOPAPERFORMS_URL },
  ];

  pgPrograms: ProgramCard[] = [
    { title: 'Masters of Com Application', years: 2, routerLink: '/courses/masters-computer-application', applyHref: NOPAPERFORMS_URL },
    { title: 'MBA', years: 2, routerLink: '/courses/master-business-administration', applyHref: NOPAPERFORMS_URL },
    { title: 'M.Tech in CS & Engg', years: 2, routerLink: '/courses/mtech-cse-engg', applyHref: NOPAPERFORMS_URL },
    { title: 'M.Tech in ETC (VLSI Design & Emb System)', years: 2, routerLink: '/courses/mtech-etc-vlsi-embed-system', applyHref: NOPAPERFORMS_URL },
    { title: 'M.Tech in Mech Engg(Heat Power Engg)', years: 2, routerLink: '/courses/mtech-mechanical-heat-power-engg', applyHref: NOPAPERFORMS_URL },
    { title: 'M.Tech in Mech Engg(CADME)', years: 2, routerLink: '/courses/mtech-mech-cad-cam', applyHref: NOPAPERFORMS_URL },
    { title: 'M.Tech in Civil Engg(Structural Engg)', years: 2, routerLink: '/courses/mtech-structural-engg', applyHref: NOPAPERFORMS_URL },
    { title: 'M.Tech in Elect Engg(Power Systems)', years: 2, routerLink: '/courses/mtech-electrical-power-sytem', applyHref: NOPAPERFORMS_URL },
    { title: 'M.Tech in Elect Engg(Control Systems)', years: 2, routerLink: '/courses/mtech-control-sytem', applyHref: NOPAPERFORMS_URL },
  ];

  pgdPrograms: ProgramCard[] = [
    {
      title: 'PG Diploma in AI & DS', years: 1,
      href: 'https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcempune/pdf/pg-ai-ds.pdf', learnMoreTarget: '_blank',
      applyHref: GOOGLE_FORM_URL
    },
    {
      title: 'PG Diploma in Startup Ecosystem', years: 1,
      href: 'https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcempune/pdf/PGD-Startup-Ecosystem.pdf', learnMoreTarget: '_blank',
      applyHref: GOOGLE_FORM_URL
    },
  ];

  onTabClick(tab: string): void {
    this.activeTab = tab;
  }

  // Only routerLink points at an on-site course page worth sharing — href is
  // often a PDF brochure or CDN asset, so it falls back to the current page.
  shareUrl(p: ProgramCard): string {
    if (p.routerLink) return `${window.location.origin}${p.routerLink}`;
    return window.location.href;
  }
}
